import { createContext } from "react";
import { IQuestion, ISendQuestion } from "../interfaces";

export interface IEvaluationContext {
  isErrorRemaining: boolean,
  question: IQuestion;
  sendQuestion: ISendQuestion;
  allQuestions: number;
  isMinorTablet: boolean;
  handleNextQuestion: () => void;
  handleOptionOption: (option: string) => void;
  handleOpenTimeFinishModal: () => void;
  handleOpenTwoMinutesModal: () => void;
}

const EvaluationContext = createContext<IEvaluationContext>({
  isErrorRemaining: false,
  question: {
    score: 0,
    isLastQuestion: false,
    answers: [],
    id: "",
    content: "",
    order: 0,
  },
  sendQuestion: {
    questionId: "",
    answerId: "",
    sentBy: "CANDIDATE",
  },
  allQuestions: 0,
  isMinorTablet: false,
  handleNextQuestion: () => {},
  handleOptionOption: () => {},
  handleOpenTimeFinishModal: () => {},
  handleOpenTwoMinutesModal: () => {},
});

export default EvaluationContext;
